import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, forwardRef, ElementRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ModuleModel } from '../models/ModuleModel';
import { ModuleListModel } from '../models/ModuleListModel';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import * as fromStore from '../store/reducers';
import { ModuleConfiguration } from '../business-rule.module.config';
import * as actions from '../../pillar/dashboard/store/actions';
import { Sort, MatDialog } from '@angular/material';
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import { EditParameterComponent as EditDateThresholdComponent } from "./edit-parameter.component";
import { BaseAddressInterceptor } from '../../core/interceptors/BaseAddressInterceptor';
import { RuleService } from '../services/RuleService';
import { ExportRuleModel } from '../models/ExportRuleModel';

@Component({
  selector: 'brd-rule-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => RuleTileComponent) }],
  templateUrl: './rule-tile.component.html',
  styleUrls: ['./rule-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class RuleTileComponent extends TileComponent implements OnInit, OnDestroy {
  displayedColumns = ['name', 'actions'];
  dataSource: StoreDataSource<ModuleListModel>;
  loading$: Observable<boolean>;
  destroyed$ = new Subject<boolean>();
  errors$: Observable<string[]>;
  dataSetList: ModuleListModel[];
  listDataSubject = new Subject <ModuleListModel[]>();
  listData$: Observable<ModuleListModel[]>;
  list: ModuleListModel[];
  sortDirection = 'asc';
  editPermission = 'RuleModule.BusinessRule:Edit';
  exportRulesPermission = 'RuleModule.BusinessRule:Export';
  viewErrorMessageCodesPermission = 'SubmissionModule.MessageCodes:View';
  @ViewChild(SearchComponent)
  search: SearchComponent;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  constructor(private store: Store<TileState<ModuleListModel, ModuleModel>>,
              private currentUserService: CurrentUserService,
              private baseAddressInterceptor: BaseAddressInterceptor,
              private router: Router,
              private changeDetectorRef: ChangeDetectorRef,
              elementRef: ElementRef,
              private tileContainer: TileContainer,
              private dialog: MatDialog,
              private ruleService: RuleService ) {
    super(elementRef);
    tileContainer.tileComponents.push(this);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  ngOnInit() {
    if (this.search) {
      this.search
        .searchControl
        .valueChanges
        .debounceTime(500)
        .takeUntil(this.destroyed$)
        .subscribe((value) => {
          this.updateList(value);
        });
    }

    this.listData$ = this.listDataSubject.asObservable();
    this.store.select(fromStore.getRuleList)
      .takeUntil(this.destroyed$)
      .subscribe(list => {
        this.dataSetList = list;
        this.updateList(this.search.searchControl.value);
      });

    this.store.dispatch(new actions.QueryListAction(ModuleConfiguration.moduleName,
      ModuleListModel,
      {
        page: 0,
        pageSize: 200,
        sortDirection: "asc"
      }));

    this.loading$ = this.store.select(fromStore.getRuleListLoading);
  }

  private compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortData(sort: Sort) {
    this.sortDirection = sort.direction || 'asc';
    this.updateList(this.search.searchControl.value);
  }

  private updateList(filterString: string) {
    var filteredDataSets = this.dataSetList.filter(ds => ds.moduleDisplayName.toLowerCase().includes(filterString.toLowerCase()));
    filteredDataSets.sort((a, b) => {
      const isAsc = this.sortDirection === 'asc';
      return this.compare(a.moduleDisplayName, b.moduleDisplayName, isAsc);
    });
    this.listDataSubject.next(filteredDataSets);
    this.changeDetectorRef.markForCheck();
  }

  private selectDataSet(moduleName) {
    this.router.navigateByUrl('rule-collection-dashboard/' + moduleName);
  }

  showDialog(): void {
    this.dialog.open(EditDateThresholdComponent, {
      panelClass: 'customized-dialog',
      width: '648px'
    });
  }

  private exportRules(moduleName: string): void {
    var moduleModel = new ExportRuleModel();
    moduleModel.moduleName = moduleName;
    this.ruleService.exportRules(moduleModel).take(1)
      .subscribe(r => {
        this.ruleService.openExtract(r.model.url, r.model);
      });;
  }

  exportButtonText() {
    return this.currentUserService.hasPermission(this.viewErrorMessageCodesPermission) ? 'Export Rules, Errors and Warnings' : 'Export Rules';
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/components/rule-tile.component.ts